module.exports = __webpack_public_path__ + "static/media/Pin_Job_Tech_Large.c37b8730.svg";